export default __webpack_public_path__ + "static/media/menu_consultation.a127e105.svg";